export const CONTACT = {
  phoneDisplay: "(360) 930-4399",
  phoneHref: "tel:+13609304399",
  smsHref: "sms:+13609304399",
  email: "bryan@solidhomeservice.com",
  reviewUrl: "https://g.page/r/CQq3-foBVx4iEAI/review",
  hours: "Mon–Fri 9:00 AM – 5:00 PM",
  area: "North Kitsap County, WA",
};
